import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody } from 'reactstrap'
import {
  getSystemSetup,
  onChangeOfferLetter,
  updateOfferLetter,
} from 'store/Recruitment/actions.js'
import TextEditor from '../../TextEditor/index.js'

const textEditorOptions = {
  buttonList: [
    ['font', 'fontSize', 'formatBlock', 'list', 'fontColor'],
    ['fontColor', 'hiliteColor', 'align', 'list'],
    ['bold', 'underline', 'italic'],
  ],
  styles: `
  .my-editor .se-wrapper-inner .se-editable {
    border-radius: 90px;
  }
  `,
}

const chunkArray = (arr, size) => {
  const chunks = []
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size))
  }
  return chunks
}

const placeholders = [
  { label: 'Applicant Name', placeholder: '{applicant_name}' },
  { label: 'Job title', placeholder: '{job_title}' },
  { label: 'Working Location', placeholder: '{workplace_location}' },
  { label: 'Salary Type', placeholder: '{salary_type}' },
  { label: 'App Name', placeholder: '{app_name}' },
  { label: 'Job type', placeholder: '{job_type}' },
  { label: 'Days Of Week', placeholder: '{days_of_week}' },
  { label: 'Salary Duration', placeholder: '{salary_duration}' },
  { label: 'Company Name', placeholder: '{company_name}' },
  { label: 'Proposed Start Date', placeholder: '{start_date}' },
  { label: 'Salary', placeholder: '{salary}' },
  // { label: 'Offer Expiration Date', placeholder: '{offer_expiration_date}' },
]

const placeholderColumns = chunkArray(placeholders, 4)

function OfferLetterSettings() {
  const dispatch = useDispatch()

  const { offerLetterText, currentSystemSetupData, currentSystemSetupRows } =
    useSelector((store) => store.recruitment)

  const onAddChange = (value) => {
    dispatch(onChangeOfferLetter(value))
  }

  useEffect(() => {
    dispatch(getSystemSetup())
  }, [dispatch])

  return (
    <>
      <p className='title mb-3'>Placeholders</p>
      <Card>
        <CardBody>
          <div className='row'>
            {placeholderColumns.map((group, colIndex) => (
              <div className='col-md-4' key={colIndex}>
                {group.map((item, idx) => (
                  <p className='my-2' key={idx}>
                    <strong>{item.label}</strong>:{' '}
                    <span className='text-info'>{item.placeholder}</span>
                  </p>
                ))}
              </div>
            ))}
          </div>
        </CardBody>
      </Card>

      <p className='title mb-1'>Format</p>
      <TextEditor
        onChangeText={(e) => onAddChange(e)}
        setOptions={textEditorOptions}
        textContent={offerLetterText}
      />
      <button
        onClick={() => dispatch(updateOfferLetter())}
        className='btn btn-info ml-auto mt-3'
        style={{ width: 'fit-content' }}
      >
        Save Changes
      </button>
    </>
  )
}

export default OfferLetterSettings
